var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12.0208C3 11.6271 3.31814 11.308 3.71058 11.308H7.50031C7.89275 11.308 8.21089 11.6271 8.21089 12.0208C8.21089 12.4144 7.89275 12.7336 7.50031 12.7336H3.71058C3.31814 12.7336 3 12.4144 3 12.0208Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2144 2.44716L19.5542 3.79123C20.3006 4.5399 20.0163 5.67982 19.3868 6.31137L17.7897 7.91344L16.7816 8.92473L14.3622 11.3516C13.7326 11.9832 12.5963 12.2683 11.85 11.5196L10.5101 10.1756C9.76377 9.42691 10.048 8.28698 10.6776 7.65544L15.7021 2.61517C16.3317 1.98363 17.468 1.6985 18.2144 2.44716ZM11.5725 9.50354C11.5725 10.0284 11.9966 10.4539 12.5199 10.4539C13.0431 10.4539 13.4673 10.0284 13.4673 9.50354C13.4673 8.97865 13.0431 8.55314 12.5199 8.55314C11.9966 8.55314 11.5725 8.97865 11.5725 9.50354Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2375 18.6736C8.96718 18.6736 6.31605 16.0142 6.31605 12.7336H4.8949C4.8949 16.561 7.80513 19.7066 11.5269 20.0651V20.5744H10.3426C9.95021 20.5744 9.63207 20.8935 9.63207 21.2872C9.63207 21.6809 9.95021 22 10.3426 22H14.1324C14.5248 22 14.8429 21.6809 14.8429 21.2872C14.8429 20.8935 14.5248 20.5744 14.1324 20.5744H12.9481V20.0651C16.6699 19.7066 19.5801 16.561 19.5801 12.7336C19.5801 10.8904 18.9052 9.20528 17.7897 7.91345L16.7816 8.92474C17.6414 9.95588 18.159 11.2841 18.159 12.7336C18.159 16.0142 15.5078 18.6736 12.2375 18.6736Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.393f5300549a66c97d4b9b603aff8775.svg";
export { ForwardRef as ReactComponent };